import WinHighlightController from "../../controllers/WinHighlightController";
import MainGridController from "../../controllers/grid/MainGridController";
import { COMPONENTS } from "../../lib/constants";
import { WinHighlightViewGrid } from "./WinHightlightViewGrid";

export const WinHighlight = {
  name: COMPONENTS.WIN_HIGHLIGHT,
  child: true,
  zIndex: 2,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: WinHighlightController,
      name: "WinHighlightController",
      config: {
        item: "win_highlight",
        win: 0,
        holder: "win_highlight_holder",
      },
    },
    {
      Controller: MainGridController,
      name: "WinHighlightViewGrid",
      config: WinHighlightViewGrid,
    },
  ],
  components: [
    {
      name: "win_highlight_holder_up",
      type: "Sprite",
      components: [
        {
          name: "win_highlight_holder",
          type: "Sprite",
          position: {
            x: 320,
            y: 270,
          },
          components: [
            {
              name: "win_highlight",
              type: "SimpleButton",
              components: [
                {
                  name: "win_counter",
                  type: "CustomText",
                  text: "WIN_HIGHLIGHT_COUNTER",
                },
                {
                  name: "core",
                  type: "Sprite",
                  position: { x: 0, y: 0 },
                  anchor: {
                    x: 0.5,
                    y: 0.5,
                  },
                  components: [
                    {
                      name: "core_img",
                      type: "Sprite",
                      img: "scroll_paper",
                      position: { x: 0, y: 0 },
                      anchor: {
                        x: 0.5,
                        y: 0.5,
                      },
                    },
                    {
                      name: "cloud",
                      type: "Sprite",
                      img: "cloud",
                      position: { x: 0, y: 40 },
                      anchor: {
                        x: 0.5,
                        y: 0.5,
                      },
                    },
                    {
                      name: "cloud_back",
                      type: "Sprite",
                      img: "cloud",
                      position: { x: 0, y: -150 },
                      anchor: {
                        x: 0.5,
                        y: 0.5,
                      },
                      scale: {
                        x: 0.6,
                        y: 0.6,
                      },
                      alpha: 0.3,
                    },
                    {
                      name: "wing_left",
                      type: "Sprite",
                      img: "scroll_side_left",
                      position: { x: -40, y: 0 },
                      anchor: {
                        x: 0.5,
                        y: 0.5,
                      },
                    },
                    {
                      name: "wing_right",
                      type: "Sprite",
                      img: "scroll_side_right",
                      position: { x: 40, y: 0 },
                      anchor: {
                        x: 0.5,
                        y: 0.5,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
